<template>
  <div class="dialog-margin">
    <div>
      <span>物品编号：{{ goodsNo }}</span>
    </div>
    <div>
      <qx-select-table :data="batchArray">
        <qx-select-table-column prop="batchNumSource" label="批次号" width="200">
          <template v-slot:button>
            <el-button type="primary" @click="addList">
              新增批次
            </el-button>
          </template>
        </qx-select-table-column>
        <qx-select-table-column prop="mainQuantity" label="主数量" :is-slot="true">
          <template v-slot="{scope}">
            <qx-input-number v-model="scope.row.mainQuantity"
                             placeholder="请输入主数量"
                             :controls="false"
                             :min="0"
                             :precision="1"/>
          </template>
        </qx-select-table-column>
        <qx-select-table-column prop="slaveQuantity" label="件数" :is-slot="true">
          <template v-slot="{scope}">
            <qx-input-number v-model="scope.row.slaveQuantity"
                             placeholder="请输入件数"
                             :controls="false"
                             :min="0"
                             :precision="0"/>
          </template>
        </qx-select-table-column>
        <el-table-column label="操作" width="50px">
          <template slot-scope="scope">
            <div class="table-operator" v-if="!scope.row.isNew">
              <i class="el-icon-third-lajitong" @click="remove(scope.$index)"/>
            </div>
          </template>
        </el-table-column>
      </qx-select-table>
      <div class="control-button padding-10">
        <el-button type="primary" @click="submit">确认</el-button>
        <el-button @click="close">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @Description: 批次号弹窗
 * @Author: 菩萨蛮
 * @Date: 2020/9/28 2:03 下午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'BatchListDialog',
  props: {
    rowIndex: { type: Number, default: -1 },
    goodsNo: { type: String, default: '' },
    batchList: { type: Array }
  },
  data() {
    return {
      batchArray: []
    };
  },
  created() {
    this.setDefaultArray();
  },
  methods: {
    setDefaultArray() {
      this.batchArray = this.utils.copy(this.batchList);
    },
    addList() {
      this.batchArray.push({
        batchNumSource: '',
        mainQuantity: 0,
        slaveQuantity: 0
      });
    },
    remove(i) {
      this.batchArray.splice(i, 1);
    },
    submit() {
      const { isEmpty } = this.utils;
      const batchList = this.batchArray.filter(b => !isEmpty(b.batchNumSource));
      if (batchList.some(b => isEmpty(b.mainQuantity) && isEmpty(b.slaveQuantity))) {
        this.$message.error('主数量和件数不可都为空！');
        return;
      }
      if (batchList.some(b => b.mainQuantity === 0)) {
        this.$message.error('主数量不可为0！');
        return;
      }
      if (batchList.some(b => b.slaveQuantity === 0)) {
        this.$message.error('件数不可为0！');
        return;
      }
      this.$emit('submit', { data: batchList, index: this.rowIndex });
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
